<template>
  <div>
    <div v-if="followups && followups.length">
      <app-timeline>
        <app-timeline-item
          v-for="(item, index) in followups"
          :key="index"
          :variant="getPriorityVariant(item.priority)"
        >
          <div class="d-flex justify-content-between flex-wrap mb-1">
            <h6 class="mb-0">
              {{ getFollowupUserName(item) }} - {{ item.followuptype || "Follow up" }}
            </h6>
            <small>{{ item.datetime || "" }}</small>
          </div>
          <p class="mb-50"><strong>Remarks:</strong> {{ item.remarks || "NA" }}</p>
          <p class="mb-0"><strong>Next:</strong> {{ item.nextfollowupafterdays || 0 }} days</p>
        </app-timeline-item>
      </app-timeline>
    </div>
    <b-alert v-else show variant="light">
      No follow up history found.
    </b-alert>
  </div>
</template>

<script>
import { BAlert } from "bootstrap-vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";

export default {
  components: {
    BAlert,
    AppTimeline,
    AppTimelineItem,
  },
  props: {
    followups: {
      type: Array,
      default: () => [],
    },
    users: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getPriorityVariant(priority) {
      if (priority === "HOT") return "danger";
      if (priority === "WARM") return "success";
      if (priority === "COLD") return "info";
      return "primary";
    },
    getFollowupUserName(followup) {
      if (followup.enterby && typeof followup.enterby === "number") {
        const user = this.users.find((u) => u.id === followup.enterby);
        if (user) return user.fullname || user.name || `User #${followup.enterby}`;
      }
      if (followup.enterby && typeof followup.enterby === "string") return followup.enterby;
      if (followup.enterby_data && followup.enterby_data.length > 0) {
        return followup.enterby_data[0].fullname || followup.enterby_data[0].name || "Unknown";
      }
      return "System";
    },
  },
};
</script>
